export default __webpack_public_path__ + "static/char-s-09-jp-f30f116ba7e0f5fe18bedb10848a13ba.png";